module.exports = __webpack_public_path__ + "img/horizontal_logo.964903b9.png";